/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./preview-btn.vue?vue&type=template&id=22a3ef34&scoped=true&"
import script from "./preview-btn.vue?vue&type=script&lang=ts&"
export * from "./preview-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3ef34",
  null
  
)

export default component.exports